import React, {Fragment} from "react";

import PricingSidebar from "./PricingSidebar/PricingSidebar";
import PricingDetails from "./PricingDetails/PricingDetails";
import PricingPriceGroups from "./PricingPriceGroups/PricingPriceGroups";
import PricingFeatures from "./PricingFeatures/PricingFeatures";
import PricingFilters from "./PricingFilters/PricingFilters";


const PricingMain = () => {

  return (
    <Fragment>
      <PricingSidebar/>
      <PricingFilters/>
      <div className="flex pr-main scrollbar3 flex--stretch">
        <main className="pt-3 pl-2 pr-1 pb-6 flex-1 flex flex--column">
          <PricingDetails/>
          <PricingPriceGroups/>
          <PricingFeatures/>
        </main>
      </div>
    </Fragment>
  )
};

export default PricingMain
